import { useCallback, useEffect, useRef, useState } from "react";
import { getMemberGuideList } from "../../services/membersAdminService";
import { ApiMember } from "../../pages/manageMembers/models/ManageMemberModel";
import { useSearch } from "../community/useSearch";

export const useMemberGuideList = (search: string) => {
    const isMoutedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<ApiMember[]>([]);
    const searchValue = useSearch(search, 250);

    useEffect(() => {
        isMoutedRef.current = true;
        return () => {
            isMoutedRef.current = false;
        }
    });

    const load = useCallback(async () => {
        if(loading || !searchValue)
        {
            setList([]);
            return;
        }
        try {
            setLoading(true);
            const _data = await getMemberGuideList(searchValue);
            if(!isMoutedRef.current)
                return;

            if(!!_data && !!_data.results)
                setList(_data.results);
        }
        finally {
            if(!isMoutedRef.current)
                return;
            setLoading(false);
        }
    }, [searchValue]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, list, reset: () => setList([]) }
}